module.exports = __webpack_public_path__ + "img/2.b62bb43.jpg";